"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyBrowserModal = void 0;
var react_1 = __importDefault(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
require("./LegacyBrowserModal.scss");
var SupportEmailLink_1 = require("@app/components/SupportEmailLink");
var Modal_1 = require("@app/components/layout/Modal");
var ModalContent_1 = require("@app/components/layout/ModalContent");
var matomo_1 = require("@app/shared/matomo");
var renderFooter = function (props) {
    var skipAction = function () {
        props.onStopAspera();
        props.onUseBlastLite();
        new matomo_1.MatomoTracker().trackEvent('Legacy Browser', 'Use Blast Lite');
    };
    var skipButton = !props.isPreLogin ?
        react_1.default.createElement("button", { type: "button", className: "button is-light", onClick: skipAction }, "Continue with Blast Lite") : null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        skipButton,
        react_1.default.createElement("div", { className: "has-text-right", style: { width: '100%' } },
            react_1.default.createElement("p", null,
                "Need Help? ",
                react_1.default.createElement(SupportEmailLink_1.SupportEmailLink, null)))));
};
var LegacyBrowserModal = function (props) {
    var onCloseModal = function () {
        if (props.onClose) {
            props.onStopAspera();
            props.onClose();
            new matomo_1.MatomoTracker().trackEvent('Legacy Browser', 'Closed Modal');
        }
    };
    var printedBrowserName = (react_device_detect_1.browserName === 'IE') ? 'Internet Explorer' : react_device_detect_1.browserName;
    var legacyModalContent = !props.isPreLogin ?
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null,
                "We notice you are using ",
                react_1.default.createElement("strong", null, printedBrowserName),
                ". As a result, features and functionality of Aspera Connect may be impacted."),
            react_1.default.createElement("p", null,
                "To ensure you have the best Blast experience possible, we strongly recommend \u00A0",
                react_1.default.createElement("strong", null, "you change your browser"),
                ". Blast works most optimally on the following browsers: Firefox, Chrome, or the new Microsoft Edge.")) :
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null,
                "We notice you are using ",
                react_1.default.createElement("strong", null, printedBrowserName),
                " which is no longer supported."),
            react_1.default.createElement("p", null,
                "To ensure you have the best Blast experience possible, please \u00A0",
                react_1.default.createElement("strong", null, "use a different browser"),
                ". Blast works most optimally on the following browsers: Firefox, Chrome, or the new Microsoft Edge."));
    return (react_1.default.createElement(Modal_1.Modal, __assign({}, props, { closeOnEscape: true }),
        react_1.default.createElement(ModalContent_1.ModalContent, { title: "INCOMPATIBLE BROWSER", onCloseClick: onCloseModal, className: "legacy-browser-modal-content", renderFooter: function () { return renderFooter(props); } }, legacyModalContent)));
};
exports.LegacyBrowserModal = LegacyBrowserModal;
var mapStateToProps = function (store) {
    return {
        isInternal: store.auth.userInfo ? store.auth.userInfo.isInternal : false
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(exports.LegacyBrowserModal);
